import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { XLabelPaddingComponent } from '../x-label-padding/x-label-padding.component';
import { NgIf } from '@angular/common';
import {XLabelComponent} from "../x-label/x-label.component";
import {TMenuItem} from "../x-menu/x-menu.component";
import {XDropdownWrapperComponent} from "../x-dropdown-wrapper/x-dropdown-wrapper.component";

@Component({
  selector: 'app-x-select',
  standalone: true,
  imports: [
    SvgIconComponent,
    XLabelPaddingComponent,
    NgIf,
    XDropdownWrapperComponent,
  ],
  templateUrl: './x-select.component.html',
  styleUrl: './x-select.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XSelectComponent {
  @Input() options: TMenuItem[] = [];
  @Input() value: string = '';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  @Input() leadingIcon: string | null = null;
  @Input() appearance: 'default' | 'borderless' = 'default';

  public get selectedText() {
    return this.options.find((it) => it.id === this.value)?.text ?? 'Not selected';
  }
}
